import toast from "react-hot-toast";

// Toast management with debounce
let lastToastTime = 0;
export const showToastOnce = (message) => {
  const now = Date.now();
  if (now - lastToastTime > 2000) {
    toast.error(message);
    lastToastTime = now;
  }
};

export const showSuccessToast = (message) => {
  toast.success(message);
};

export const validateNumericInput = (value) => {
  return value === "" || /^\d+$/.test(value);
};

export const getNumericValidationMessage = (fieldName) => {
  return `Please enter only numbers for ${fieldName}`;
};

export const createInitialFlavour = () => ({
  name: "",
  images: [],
  nutritionalInformation: {
    calories: null,
    carbohydrates: null,
    proteins: null,
    fats: null,
  },
  tags: [],
  subText: "",
  ingredients: [],
  sizes: [
    {
      name: "",
      quantity: null,
      images: [],
      price: null,
      discountedPrice: null,
    },
  ],
  stockStatus: null,
  allergenInformation: "",
  dietaryPreferences: [],
});

export const createInitialFlavourInput = () => ({
  tagInput: "",
  ingredientInput: "",
  _id: "",
  sizeInputs: [
    {
      _id: "",
      name: "",
      quantity: null,
      images: [],
      price: null,
      discountedPrice: null,
    },
  ],
});

export const createInitialSize = () => ({
  name: "",
  quantity: null,
  images: [],
  price: null,
  discountedPrice: null,
});

export const updateFlavourField = (flavours, flavourIdx, field, value) => {
  return flavours.map((flavour, idx) =>
    idx === flavourIdx ? { ...flavour, [field]: value } : flavour
  );
};

export const updateNutritionalField = (flavours, flavourIdx, field, value) => {
  return flavours.map((flavour, idx) =>
    idx === flavourIdx
      ? {
          ...flavour,
          nutritionalInformation: {
            ...flavour.nutritionalInformation,
            [field]: value,
          },
        }
      : flavour
  );
};

export const updateSizeField = (
  flavours,
  flavourIdx,
  sizeIdx,
  field,
  value
) => {
  return flavours.map((flavour, idx) =>
    idx === flavourIdx
      ? {
          ...flavour,
          sizes: flavour.sizes.map((size, sizeIndex) =>
            sizeIndex === sizeIdx ? { ...size, [field]: value } : size
          ),
        }
      : flavour
  );
};

export const updateSizeImages = (flavours, flavourIdx, sizeIdx, newImages) => {
  return flavours.map((flavour, idx) =>
    idx === flavourIdx
      ? {
          ...flavour,
          sizes: flavour.sizes.map((size, sizeIndex) =>
            sizeIndex === sizeIdx
              ? {
                  ...size,
                  images: [...(size.images || []), ...newImages],
                }
              : size
          ),
        }
      : flavour
  );
};

export const removeSizeImage = (flavours, flavourIdx, sizeIdx, imageIdx) => {
  return flavours.map((flavour, idx) =>
    idx === flavourIdx
      ? {
          ...flavour,
          sizes: flavour.sizes.map((size, sizeIndex) =>
            sizeIndex === sizeIdx
              ? {
                  ...size,
                  images:
                    size.images?.filter((_, imgIdx) => imgIdx !== imageIdx) ||
                    [],
                }
              : size
          ),
        }
      : flavour
  );
};

export const updateFlavourImages = (flavours, flavourIdx, newImages) => {
  return flavours.map((flavour, idx) =>
    idx === flavourIdx
      ? {
          ...flavour,
          images: [...(flavour.images || []), ...newImages],
        }
      : flavour
  );
};

export const removeFlavourImage = (flavours, flavourIdx, imageIdx) => {
  return flavours.map((flavour, idx) =>
    idx === flavourIdx
      ? {
          ...flavour,
          images:
            flavour.images?.filter((_, imgIdx) => imgIdx !== imageIdx) || [],
        }
      : flavour
  );
};

export const addToArray = (flavours, flavourIdx, field, value) => {
  return flavours.map((flavour, idx) =>
    idx === flavourIdx
      ? {
          ...flavour,
          [field]: [...(flavour[field] || []), value],
        }
      : flavour
  );
};

export const removeFromArray = (flavours, flavourIdx, field, itemIdx) => {
  return flavours.map((flavour, idx) =>
    idx === flavourIdx
      ? {
          ...flavour,
          [field]: flavour[field]?.filter((_, i) => i !== itemIdx) || [],
        }
      : flavour
  );
};

export const prepareFlavourData = (flavour, isUpdate = false) => {
  const finalBody = {
    name: flavour?.name,
    images: flavour?.images,
    tags: flavour?.tags,
    stockStatus: flavour?.stockStatus,
  };

  if (isUpdate && flavour?._id) {
    finalBody._id = flavour._id;
  }

  const nutritionalInformation = {};
  if (flavour?.nutritionalInformation?.calories) {
    nutritionalInformation.calories = flavour?.nutritionalInformation?.calories;
  }
  if (flavour?.nutritionalInformation?.carbohydrates) {
    nutritionalInformation.carbohydrates =
      flavour?.nutritionalInformation?.carbohydrates;
  }
  if (flavour?.nutritionalInformation?.proteins) {
    nutritionalInformation.proteins = flavour?.nutritionalInformation?.proteins;
  }
  if (flavour?.nutritionalInformation?.fats) {
    nutritionalInformation.fats = flavour?.nutritionalInformation?.fats;
  }

  if (Object.values(nutritionalInformation).length) {
    finalBody.nutritionalInformation = nutritionalInformation;
  }

  const sizes = flavour?.sizes?.map((item) => {
    const sizeObj = {
      discountedPrice: item.discountedPrice || 0,
      price: item?.price || 0,
      images: item?.images || [],
      quantity: item?.quantity || 0,
      name: item?.name || "",
    };
    if (isUpdate && item?._id) {
      sizeObj._id = item._id;
    }
    return sizeObj;
  });

  if (sizes?.length) {
    finalBody.sizes = sizes;
  }

  if (flavour?.subText) {
    finalBody.subText = flavour?.subText;
  }

  if (flavour?.ingredients) {
    finalBody.ingredients = flavour?.ingredients;
  }

  if (flavour?.allergenInformation) {
    finalBody.allergenInformation = flavour?.allergenInformation;
  }

  if (flavour?.dietaryPreferences?.length) {
    finalBody.dietaryPreferences = flavour?.dietaryPreferences?.filter((data) =>
      Boolean(data)
    );
  }

  return finalBody;
};
